'use strict';
// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('MaquinasService', function($http, RestService) {
  return {
    listSprayers: function() {
      const url = `${SERVER + API_VERSION }pulverizadores`;
      return $http.get(url);
    },

    list(filters = {}) {
      const url = `${SERVER + API_VERSION }maquinas`;
      return $http.get(url, { params: filters });
    },

    listPaginated(filters = {}) {
      filters.paginate = true;
      return RestService.getFromUrl(`${SERVER}v1/maquinas`, filters);
    },

    get: function(id) {
      const url = `${SERVER}${API_VERSION}maquinas/${id}`;
      return $http.get(url);
    },

    listGroups() {
      return $http.get(`${SERVER}v1/maquinas/grupos_maquinas`);
    },

    save(maquina) {
      if (maquina.id) {
        return this.update(maquina);
      }
      return this.create(maquina);
    },

    update(maquina) {
      const data = {
        maquina: this._getParameters(maquina)
      };
      return $http.patch(`${SERVER}v1/maquinas/${maquina.id}`, data);
    },

    create(maquina) {
      const data = {
        maquina: this._getParameters(maquina)
      };
      return $http.post(`${SERVER}v1/maquinas`, data);
    },

    deleteMaquina(id) {
      return $http.delete(`${SERVER}v1/maquinas/${id}`);
    },

    // eslint-disable-next-line complexity
    _getParameters(maquina) {
      const object = {
        descricao: maquina.descricao,
        cd_grupo: maquina.grupo.id,
        alimentacao: maquina.alimentacao,
        propriedades: _.flatMap(maquina.propriedades, 'id'),
        capacidade_tanque: maquina.capacidade_tanque || null,
        st_conjunto: maquina.st_conjunto === true ? 'S' : 'N',
        tipo_controle_manutencao: !maquina.id ? maquina.tipo_controle_manutencao : null,
        dt_baixa: maquina.id ? maquina.dt_baixa : null,
        integracao_gps_id: maquina.integracao_gps_id || null
      };
      if (maquina.largura_trabalho) {
        object.largura_trabalho = maquina.largura_trabalho;
      }
      return object;
    }
  };
});
